import {Language} from 'core/types';
import {SiteEnum} from 'core/enum';

export const getDefaultLanguageBySite = (site: SiteEnum) => (site === SiteEnum.BEL ? Language.en : Language.cs);
